import http from './request';



//获取图片验证码
export const getImgCode = (params) => http({
        url: '/sgzg/getImgCode',
        method: 'post',
        params: params
    })
    //检查唯一性
export const checkOne = (params) => http({
    url: '/sgzg/checkOne',
    method: 'post',
    params: params
})
export const reg = (params) => http({
    url: '/sgzg/reg',
    method: 'post',
    params: params
})
export const login = (params) => http({
    url: '/sgzg/login',
    method: 'post',
    params: params
})
export const autologin = (params) => http({
    url: '/sgzg/autologin',
    method: 'post',
    params: params
})
export const getMyUserinfo = (params) => http({
    url: '/sgzg/getMyUserinfo',
    method: 'post',
    params: params
})
export const editUname = (params) => http({
    url: '/sgzg/editUname',
    method: 'post',
    params: params
})
export const editMyUinfo = (params) => http({
    url: '/sgzg/editMyUinfo',
    method: 'post',
    params: params
})
export const searchUser = (params) => http({
    url: '/sgzg/searchUser',
    method: 'post',
    params: params
})
export const searchForum = (params) => http({
    url: '/sgzg/searchForum',
    method: 'post',
    params: params
})
export const updateMyUpass = (params) => http({
    url: '/sgzg/updateMyUpass',
    method: 'post',
    params: params
})
export const sendEmailCode = (params) => http({
    url: '/sgzg/sendEmailCode',
    method: 'post',
    params: params
})
export const bandEmail = (params) => http({
    url: '/sgzg/bandEmail',
    method: 'post',
    params: params
})
export const emailIsVaild = (params) => http({
    url: '/sgzg/emailIsVaild',
    method: 'post',
    params: params
})
export const sendEmailCodeForFindUpass = (params) => http({
    url: '/sgzg/sendEmailCodeForFindUpass',
    method: 'post',
    params: params
})
export const updateUpassByEmail = (params) => http({
    url: '/sgzg/updateUpassByEmail',
    method: 'post',
    params: params
})
export const getTypeForumList = (params) => http({
    url: '/sgzg/getTypeForumList',
    method: 'post',
    params: params
})
export const getTypeSubList = (params) => http({
    url: '/sgzg/getTypeSubList',
    method: 'post',
    params: params
})
export const showAddForumTip = (params) => http({
    url: '/sgzg/showAddForumTip',
    method: 'post',
    params: params
})
export const hideAddForumTip = (params) => http({
    url: '/sgzg/hideAddForumTip',
    method: 'post',
    params: params
})
export const getTypeForumInfo = (params) => http({
    url: '/sgzg/getTypeForumInfo',
    method: 'post',
    params: params
})
export const forumpage = (params) => http({
    url: '/sgzg/forumpage',
    method: 'post',
    params: params
})
export const forumtop = (params) => http({
    url: '/sgzg/forumtop',
    method: 'post',
    params: params
})
export const creatChatRoom = (params) => http({
    url: '/sgzg/creatChatRoom',
    method: 'post',
    params: params
})
export const commentpage = (params) => http({
    url: '/sgzg/commentpage',
    method: 'post',
    params: params
})
export const saveComment = (params) => http({
    url: '/sgzg/saveComment',
    method: 'post',
    params: params
})
export const delComment = (params) => http({
    url: '/sgzg/delComment',
    method: 'post',
    params: params
})
export const getUserActionForIndex = (params) => http({
    url: '/sgzg/getUserActionForIndex',
    method: 'post',
    params: params
})
export const hitcomment = (params) => http({
    url: '/sgzg/hitcomment',
    method: 'post',
    params: params
})
export const getVoteItemList = (params) => http({
    url: '/sgzg/getVoteItemList',
    method: 'post',
    params: params
})
export const getVotePeopleList = (params) => http({
    url: '/sgzg/getVotePeopleList',
    method: 'post',
    params: params
})
export const myMessageNotReadNum = (params) => http({
    url: '/sgzg/myMessageNotReadNum',
    method: 'post',
    params: params
})
export const myMessagePage = (params) => http({
    url: '/sgzg/myMessagePage',
    method: 'post',
    params: params
})
export const myChatRoomPage = (params) => http({
    url: '/sgzg/myChatRoomPage',
    method: 'post',
    params: params
})
export const delMyMessageById = (params) => http({
    url: '/sgzg/delMyMessageById',
    method: 'post',
    params: params
})
export const saveMyVote = (params) => http({
    url: '/sgzg/saveMyVote',
    method: 'post',
    params: params
})
export const isatt = (params) => http({
    url: '/sgzg/isatt',
    method: 'post',
    params: params
})
export const atthe = (params) => http({
    url: '/sgzg/atthe',
    method: 'post',
    params: params
})
export const delmyForum = (params) => http({
    url: '/sgzg/delmyForum',
    method: 'post',
    params: params
})
export const getAuthorInfo = (params) => http({
    url: '/sgzg/getAuthorInfo',
    method: 'post',
    params: params
})
export const attfansmpage = (params) => http({
    url: '/sgzg/attfansmpage',
    method: 'post',
    params: params
})
export const delAttFansById = (params) => http({
    url: '/sgzg/delAttFansById',
    method: 'post',
    params: params
})
export const collectHitForumPage = (params) => http({
    url: '/sgzg/collectHitForumPage',
    method: 'post',
    params: params
})
export const cancelForumCollectHit = (params) => http({
    url: '/sgzg/cancelForumCollectHit',
    method: 'post',
    params: params
})
export const authorForumpage = (params) => http({
    url: '/sgzg/authorForumpage',
    method: 'post',
    params: params
})

export const getForumDetail = (params) => http({
    url: '/sgzg/getForumDetail',
    method: 'post',
    params: params
})


export const releaseForum = (params) => http({
    url: '/sgzg/releaseForum',
    method: 'post',
    params: params
})
export const saveVoteItem = (params) => http({
    url: '/sgzg/saveVoteItem',
    method: 'post',
    params: params
})
export const delForumMedia = (params) => http({
    url: '/sgzg/delForumMedia',
    method: 'post',
    params: params
})
export const saveFroumMedias = (params) => http({
    url: '/sgzg/saveFroumMedias',
    method: 'post',
    params: params
})
export const delVoteItem = (params) => http({
    url: '/sgzg/delVoteItem',
    method: 'post',
    params: params
})
export const ishit = (params) => http({
    url: '/sgzg/ishit',
    method: 'post',
    params: params
})
export const iscollect = (params) => http({
    url: '/sgzg/iscollect',
    method: 'post',
    params: params
})
export const getAuthotrCommentPage = (params) => http({
    url: '/sgzg/getAuthotrCommentPage',
    method: 'post',
    params: params
})
export const getTeamerPage = (params) => http({
    url: '/sgzg/getTeamerPage',
    method: 'post',
    params: params
})
export const getTeamForumPage = (params) => http({
    url: '/sgzg/getTeamForumPage',
    method: 'post',
    params: params
})
export const saveForumTopBest = (params) => http({
    url: '/sgzg/saveForumTopBest',
    method: 'post',
    params: params
})
export const delForumByManager = (params) => http({
    url: '/sgzg/delForumByManager',
    method: 'post',
    params: params
})
export const agreeOrNotTeamer = (params) => http({
    url: '/sgzg/agreeOrNotTeamer',
    method: 'post',
    params: params
})
export const delTeamerById = (params) => http({
    url: '/sgzg/delTeamerById',
    method: 'post',
    params: params
})
export const exitTeam = (params) => http({
    url: '/sgzg/exitTeam',
    method: 'post',
    params: params
})
export const getNormalUserPage = (params) => http({
    url: '/sgzg/getNormalUserPage',
    method: 'post',
    params: params
})
export const addTeamer = (params) => http({
        url: '/sgzg/addTeamer',
        method: 'post',
        params: params
    })
    //admin===============================================
    //待审核用户
export const admin_wait_sh_users_page = (params) => http({
        url: '/admin/users/waitSHpage',
        method: 'post',
        params: params
    })
    //设置管理员
export const admin_users_setadmin = (params) => http({
        url: '/admin/users/setadmin',
        method: 'post',
        params: params
    })
    //设置使用成员
export const admin_users_setxianxia = (params) => http({
        url: '/admin/users/setxianxia',
        method: 'post',
        params: params
    })
    //禁言
export const admin_users_jinyan = (params) => http({
        url: '/admin/users/jinyan',
        method: 'post',
        params: params
    })
    //取消禁言
export const admin_users_canceljinyan = (params) => http({
        url: '/admin/users/canceljinyan',
        method: 'post',
        params: params
    })
    //设置临时登录密码
export const admin_users_setTempUpass = (params) => http({
        url: '/admin/users/setTUpass',
        method: 'post',
        params: params
    })
    //审核通过
export const admin_users_shpass = (params) => http({
        url: '/admin/users/shpass',
        method: 'post',
        params: params
    })
    //审核不通过
export const admin_users_shnotpass = (params) => http({
        url: '/admin/users/shnotpass',
        method: 'post',
        params: params
    })
    //批量审核
export const admin_users_shPL = (params) => http({
        url: '/admin/users/shPL',
        method: 'post',
        params: params
    })
    //获取待审核数量
export const admin_users_getWaitShNum = (params) => http({
        url: '/admin/users/getWaitShNum',
        method: 'post',
        params: params
    })
    //管理员-用户列表链接查询
export const admin_users_page = (params) => http({
        url: '/admin/users/page',
        method: 'post',
        params: params
    })
    //管理员-用户列表
export const admin_users_page2 = (params) => http({
        url: '/admin/users/page2',
        method: 'post',
        params: params
    })
    //管理员添加用户-验证唯一性
export const admin_users_checkOne = (params) => http({
        url: '/admin/users/checkOneU',
        method: 'post',
        params: params
    })
    //管理员添加编辑用户
export const admin_users_save = (params) => http({
        url: '/admin/users/save',
        method: 'post',
        params: params
    })
    //管理员删除用户
export const admin_users_del = (params) => http({
        url: '/admin/users/del',
        method: 'post',
        params: params
    })
    //分类管理-分页
export const admin_type_page = (params) => http({
        url: '/admin/type/page',
        method: 'post',
        params: params
    })
    //分类管理-添加或编辑
export const admin_type_save = (params) => http({
        url: '/admin/type/save',
        method: 'post',
        params: params
    })
    //分类管理-删除
export const admin_type_del = (params) => http({
        url: '/admin/type/del',
        method: 'post',
        params: params
    })
    //添加调研组员
export const admin_type_users_save = (params) => http({
        url: '/admin/typeUsers/save',
        method: 'post',
        params: params
    })
    //删除调研组员
export const admin_type_users_del = (params) => http({
        url: '/admin/typeUsers/del',
        method: 'post',
        params: params
    })
    // 查看某调研组员管理的板块信息
export const admin_users_type_seeTypes = (params) => http({
    url: '/admin/typeUsers/seeTypes',
    method: 'post',
    params: params
})
export const admin_type_getlist = (params) => http({
        url: '/admin/type/getlist',
        method: 'post',
        params: params
    })
    //删除某人的全部调研组员
export const admin_type_users_del_by_manageUid = (params) => http({
    url: '/admin/typeUsers/delByManageUid',
    method: 'post',
    params: params
})

//设置某人为调研组员
export const admin_type_users_setDiaoyanByManageUid = (params) => http({
    url: '/admin/typeUsers/setDiaoyanByManageUid',
    method: 'post',
    params: params
})

//帖子管理
export const admin_forum_page = (params) => http({
    url: '/admin/forum/page',
    method: 'post',
    params: params
})

export const admin_forum_del = (params) => http({
    url: '/admin/forum/del',
    method: 'post',
    params: params
})
export const admin_forum_getTrashNum = (params) => http({
    url: '/admin/forum/getTrashNum',
    method: 'post',
    params: params
})
export const admin_forum_saveTopBest = (params) => http({
    url: '/admin/forum/saveTopBest',
    method: 'post',
    params: params
})
export const admin_forum_showNormal = (params) => http({
    url: '/admin/forum/showNormal',
    method: 'post',
    params: params
})
export const admin_forum_move = (params) => http({
    url: '/admin/forum/move',
    method: 'post',
    params: params
})
export const admin_comment_page = (params) => http({
    url: '/admin/comment/page',
    method: 'post',
    params: params
})
export const admin_comment_del = (params) => http({
    url: '/admin/comment/del',
    method: 'post',
    params: params
})

export const admin_comment_getTrashNum = (params) => http({
    url: '/admin/comment/getTrashNum',
    method: 'post',
    params: params
})
export const admin_comment_saveTop = (params) => http({
    url: '/admin/comment/saveTop',
    method: 'post',
    params: params
})
export const admin_comment_showNormal = (params) => http({
    url: '/admin/comment/showNormal',
    method: 'post',
    params: params
})
export const admin_getUTPage = (params) => http({
    url: '/admin/typeUsers/page',
    method: 'post',
    params: params
})

export const admin_ut_agreeOrNot = (params) => http({
    url: '/admin/typeUsers/agreeOrNot',
    method: 'post',
    params: params
})

//载体信息管理
export const entity_list_page = (params) => http({
    url: '/entity/entitylist/page',
    method: 'post',
    params: params
})

//邮件数量管理
export const entity_list_getEmailCount = (params) => http({
    url: '/entity/entitylist/getEmailCount',
    method: 'post',
    params: params
})

//邮件发件箱管理- 一次获取全部发件箱
export const email_outbox_getUsernames = (params) => http({
    url: '/email-outbox/getUsernames',
    method: 'post',
    params: params
})

//邮件模板查询
export const email_outbox_list_page = (params) => http({
    url: '/email-outbox/page',
    method: 'post',
    params: params
})


export const email_outbox_add = (params) => http({
    url: '/email-outbox/add',
    method: 'post',
    params: params
})

export const email_outbox_edit = (params) => http({
    url: '/email-outbox/edit',
    method: 'post',
    params: params
})

export const email_outbox_del = (params) => http({
    url: '/email-outbox/del',
    method: 'post',
    params: params
})

//发件记录查询查询
export const sendrecord_list_page = (params) => http({
    url: '/sendrecord/page',
    method: 'post',
    params: params
})

//发件记录查询查询
export const sendrecord_list_getNames = (params) => http({
        url: '/sendrecord/getNames',
        method: 'post',
        params: params
    })
    //发件记录查询查询
export const sendrecord_list_getEmails = (params) => http({
        url: '/sendrecord/getEmails',
        method: 'post',
        params: params
    })
    //发件记录查询查询
export const sendrecord_list_getSends = (params) => http({
        url: '/sendrecord/getSends',
        method: 'post',
        params: params
    })
    //邮件模板查询
export const template_list_page = (params) => http({
    url: '/email-templates/page',
    method: 'post',
    params: params
})

//邮件模板查询不分页全部获取
export const template_list_all = (params) => http({
    url: '/email-templates/listAll',
    method: 'post',
    params: params
})

//一次获取全部载体去重模板名称
export const template_list_getNames = (params) => http({
    url: '/email-templates/getNames',
    method: 'post',
    params: params
})

export const template_add = (params) => http({
    url: '/email-templates/add',
    method: 'post',
    params: params
})

export const template_edit = (params) => http({
    url: '/email-templates/edit',
    method: 'post',
    params: params
})

export const template_review = (params) => http({
    url: '/email-templates/review',
    method: 'post',
    params: params
})

//邮件发送
export const entity_post_email = (params) => http({
    url: '/entity/entitylist/email',
    method: 'post',
    params: params
})

//一次获取全部载体信息
export const entity_list_all = (params) => http({
    url: '/entity/entitylist/listAll',
    method: 'post',
    params: params
})

//按照查询条件导出
export const entity_list_search = (params) => http({
    url: '/entity/entitylist/listSearch',
    method: 'post',
    params: params
})

//一次获取全部载体信息
export const entity_add = (params) => http({
    url: '/entity/entitylist/add',
    method: 'post',
    params: params
})

//一次获取全部载体信息
export const entity_edit = (params) => http({
    url: '/entity/entitylist/edit',
    method: 'post',
    params: params
})

//一次获取全部载体去重宗教
export const entity_list_getReligion = (params) => http({
    url: '/entity/entitylist/getReligion',
    method: 'post',
    params: params
})

//一次获取全部载体去重语言
export const entity_list_getLanguage = (params) => http({
    url: '/entity/entitylist/getLanguage',
    method: 'post',
    params: params
})

//一次获取全部载体去重派别
export const entity_list_getParty = (params) => http({
    url: '/entity/entitylist/getParty',
    method: 'post',
    params: params
})

//一次获取全部载体去重地区
export const entity_list_getRegion = (params) => http({
    url: '/entity/entitylist/getRegion',
    method: 'post',
    params: params
})

//一次获取全部载体去重地区
export const entity_list_getRegion2 = (params) => http({
    url: '/entity/entitylist/getRegion2',
    method: 'post',
    params: params
})

//一次获取全部载体去重类别
export const entity_list_getType = (params) => http({
    url: '/entity/entitylist/getType',
    method: 'post',
    params: params
})


export const entity_del = (params) => http({
    url: '/entity/entitylist/del',
    method: 'post',
    params: params
})

export const entity_black_mail = (params) => http({
    url: '/entity/entitylist/blackmail',
    method: 'post',
    params: params
})

export const entity_not_black_mail = (params) => http({
    url: '/entity/entitylist/notblackmail',
    method: 'post',
    params: params
})

export const entity_del_all = (params) => http({
    url: '/entity/entitylist/delAll',
    method: 'post',
    params: params
})

/
一次获取全部国家信息
export const country_list_all = (params) => http({
    url: '/country/countrylist/listAll',
    method: 'post',
    params: params
})


//分页载体信息管理
export const region_list_page = (params) => http({
    url: '/region/regionlist/page',
    method: 'post',
    params: params
})

//一次获取全部载体信息
export const region_list_all = (params) => http({
    url: '/region/regionlist/listAll',
    method: 'post',
    params: params
})

//添加信息
export const region_add = (params) => http({
    url: '/region/regionlist/add',
    method: 'post',
    params: params
})

//编辑信息
export const region_edit = (params) => http({
    url: '/region/regionlist/edit',
    method: 'post',
    params: params
})

//一次获取全部载体去重地区
export const region_list_getRegion = (params) => http({
    url: '/region/regionlist/getRegion',
    method: 'post',
    params: params
})


//按照国家获取一级地区
export const region_list_getRegionByCountry = (params) => http({
    url: '/region/regionlist/getRegionByCountry',
    method: 'post',
    params: params
})

//按照一级地区获取二级地区
export const region_list_getRegion2ByRegion = (params) => http({
    url: '/region/regionlist/getRegion2ByRegion',
    method: 'post',
    params: params
})

export const region_del = (params) => http({
    url: '/region/regionlist/del',
    method: 'post',
    params: params
})

export const region_del_all = (params) => http({
    url: '/region/regionlist/delAll',
    method: 'post',
    params: params
})